import $ from 'jquery'

if (document.getElementById('page-works')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  runReviews()
  runModal()
  runGallery()
}

/**
 * お客様の声に関する処理
 */
function runReviews() {
  const $listWrap = $('.worksReviews__lists')

  const listClass = '.js-reviews-list'
  const $list = $(listClass)

  const $listMeta = $('.worksReviews__listMeta')

  const $moreBtn = $('.worksReviews__showMore')
  const showMoreSpeed = 300

  const dispNum = 9 // 表示する件数

  /**
   * フィルター
   */
  const $filter = $('.worksReviews__filter')
  const $filterTag = $('.worksReviews__filterTag')
  $filterTag.on('click', function () {
    const $self = $(this)

    if ($self.hasClass('is-all')) {
      $self.parent().find('.is-active').removeClass('is-active')
    } else {
      $self.toggleClass('is-active')
    }

    setFilter()
  })

  /**
   * フィルターを適用する関数
   */
  function setFilter() {
    const category = []
    const size = []
    const option = []
    $filter.find('.is-active').each(function () {
      const $self = $(this)
      if ($self.data('category')) {
        category.push($self.data('category'))
      } else if ($self.data('size')) {
        size.push($self.data('size'))
      } else if ($self.data('option')) {
        option.push($self.data('option'))
      }
    })

    $listWrap.stop().animate({ opacity: 0 }, 300, () => {
      // とりあえず全リストにクラス付与
      $list.addClass('is-more')
      $list.addClass('is-hide')
      $list.slideUp(0)

      let $newList = null

      // カテゴリの絞り込み
      if (category.length) {
        if (!$newList) $newList = $list
        $newList = $newList.filter((index, item) => {
          const $item = $(item)
          if ($item.data('category') !== undefined && category.includes($item.data('category'))) {
            return $item
          }
        })
      }

      // サイズの絞り込み
      if (size.length) {
        if (!$newList) $newList = $list
        $newList = $newList.filter((index, item) => {
          const $item = $(item)
          if ($item.data('size') !== undefined && size.includes($item.data('size'))) {
            return $item
          }
        })
      }

      // オプションの絞り込み
      if (option.length) {
        if (!$newList) $newList = $list
        $newList = $newList.filter((index, item) => {
          const $item = $(item)
          if ($item.data('option') !== undefined) {
            return (
              [...option, ...$item.data('option')].filter(
                (data) => option.includes(data) && $item.data('option').includes(data)
              ).length > 0
            )
          }
        })
      }

      if ($newList) {
        $newList.removeClass('is-hide')
      } else {
        $list.removeClass('is-hide')
      }

      showMore(0)
      $listWrap.animate({ opacity: 1 }, 300)
    })
  }

  /**
   * リストのタグからフィルタリング
   */
  $listMeta.on('click', function () {
    const $self = $(this)

    const category = $self.data('category') ?? ''
    const size = $self.data('size') ?? ''

    if (category != '') {
      $filter.find(`[data-category="${category}"]`).addClass('is-active')
    }

    if (size != '') {
      $filter.find(`[data-size="${size}"]`).addClass('is-active')
    }

    const position = $filter.offset().top
    $('body, html').animate({ scrollTop: position }, 300, 'swing', () => {
      setFilter()
    })
  })

  /**
   * 初期化
   *
   * 最初の dispNum 件だけ表示
   */
  $list.addClass('is-more')
  $list.slideUp(0)
  showMore(0)

  // リスト表示
  $listWrap.animate({ opacity: 1 }, 300)

  /**
   * moreボタン
   */
  $moreBtn.on('click', () => {
    showMore(showMoreSpeed)
  })

  /**
   * 非表示にしているリストを表示する関数
   */
  function showMore(speed) {
    let i = 0
    $(listClass + '.is-more:not(.is-hide)').each((index, self) => {
      const $self = $(self)
      if (i < dispNum) {
        $self.removeClass('is-more')
        $self.slideDown(speed)
        i++
      }
    })

    // まだ非表示のリストがあるかチェック
    if ($(listClass + '.is-more:not(.is-hide)').length) {
      $moreBtn.removeClass('is-disabled')
    } else {
      $moreBtn.addClass('is-disabled')
    }
  }
}

/**
 * モーダルに関する処理
 */
function runModal() {
  const $btnPrev = $('.js-modal-prev-btn')
  const $btnNext = $('.js-modal-next-btn')

  $('.js-modal-open').on('click', function () {
    const $parent = $(this).parents('.js-reviews-list')
    const id = $parent.data('id')

    switchModalSection(id)

    $('body').addClass('open-modal')
    return false
  })

  $('.js-modal-close').on('click', () => {
    $('body').removeClass('open-modal')
    return false
  })

  $btnPrev.on('click', function () {
    switchModalSection($(this).data('id'))
    return false
  })

  $btnNext.on('click', function () {
    switchModalSection($(this).data('id'))
    return false
  })

  function switchModalSection(id) {
    $('.js-modal-section').removeClass('is-current')
    $(`.js-modal-section[data-id="${id}"]`).addClass('is-current')

    /**
     * 前・次ボタンの設定
     */
    const $listCurrent = $(`.js-reviews-list[data-id="${id}"]`)
    // const $listPrevAll = $listCurrent.prevAll('.js-reviews-list:not(.is-hide):not(.is-more)')
    // const $listNextAll = $listCurrent.nextAll('.js-reviews-list:not(.is-hide):not(.is-more)')
    const $listPrev = $listCurrent.prevAll('.js-reviews-list:not(.is-hide):not(.is-more)').eq(0)
    const $listNext = $listCurrent.nextAll('.js-reviews-list:not(.is-hide):not(.is-more)').eq(0)

    // 前ボタン
    if ($listPrev.length) {
      $btnPrev.removeClass('is-disabled')
      $btnPrev.data('id', $listPrev.data('id'))
    } else {
      $btnPrev.addClass('is-disabled')
    }

    // 次ボタン
    if ($listNext.length) {
      $btnNext.removeClass('is-disabled')
      $btnNext.data('id', $listNext.data('id'))
    } else {
      $btnNext.addClass('is-disabled')
    }
  }
}

/**
 * ギャラリーに関する処理
 */
function runGallery() {
  /**
   * フィルター
   */

  /**
   * お客様の声
   */
  const $listWrap = $('.worksGallery__lists')

  const listClass = '.worksGallery__list'
  const $list = $(listClass)

  const $moreBtn = $('.worksGallery__showMore')
  const showMoreSpeed = 300

  const dispNum = 9 // 表示する件数

  /**
   * 初期化
   *
   * 最初の dispNum 件だけ表示
   */
  $list.addClass('is-more')
  $(listClass + '.is-more').slideUp(0)
  showMore(0)

  // リスト表示
  $listWrap.animate({ opacity: 1 }, 300)

  /**
   * moreボタン
   */
  $moreBtn.on('click', () => {
    showMore(showMoreSpeed)
  })

  /**
   * 非表示にしているリストを表示する関数
   */
  function showMore(speed) {
    let i = 0
    $(listClass + '.is-more:not(.is-hide)').each((index, self) => {
      const $self = $(self)
      if (i < dispNum) {
        $self.removeClass('is-more')
        $self.slideDown(speed)
        i++
      }
    })

    // まだ非表示のリストがあるかチェック
    if ($(listClass + '.is-more:not(.is-hide)').length) {
      $moreBtn.removeClass('is-disabled')
    } else {
      $moreBtn.addClass('is-disabled')
    }
  }

  /**
   * SPコメント表示用
   */
  $list.on('click', function () {
    $(this).toggleClass('is-comment')
  })
}
